import {ReactComponent as HighlyConfidentialIcon} from '../../../assests/svg/highly-confidential.svg';
import {Grid} from '@mui/material';
import {t} from 'i18next';

interface AurHighlyConfidentialProps {
  type: 'pill' | 'badge';
  showWarningText?: boolean;
  className?: string;
  size?: 'small' | 'default';
}

const AurHighlyConfidential = (props: AurHighlyConfidentialProps) => {
  return (
    <Grid
      container
      className={`highly-confidential-container ${props.className}`}
    >
      <Grid item>
        <Grid
          container
          className={`${
            props.type === 'pill'
              ? props.size === 'small'
                ? 'small-highly-confidential-pill'
                : 'highly-confidential-pill'
              : 'highly-confidential-badge'
          }`}
        >
          <Grid item>
            <HighlyConfidentialIcon className="highly-confidential-icon" aria-label={t('highlyConfidential.label')}  />
          </Grid>
          <Grid item className="highly-confidential-text">
            {props.type === 'pill' ? (
              <span
                className={
                  props.size === 'small'
                    ? 'typo-text label2_size'
                    : `typo-text subhead3_size`
                }
              >
                {t('highlyConfidential.label')}
              </span>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {props.showWarningText && (
          <span
            className={
              props.size === 'small'
                ? 'typo-text label2_size'
                : 'typo-text label1_size'
            }
          >
            {t('highlyConfidential.warning')}
          </span>
        )}
      </Grid>
    </Grid>
  );
};

export default AurHighlyConfidential;
